import { defineStore } from "pinia";
import { useContractStore } from "./contract";
import contractnet from '@/network/contractnet'
import validation from '@/assets/js/validation.js';

const messageConfig = require("@/models/messageConfig.js")


export const useContractInfoStore = defineStore("contractinfo", {
  state: () => ({
    // 合同信息
    Contract: {
      contractType: "media+production",
      mediaCompanyEntityCode: "BM",
    },
    // 合同预定信息
    ContractBooking: {},
    // ProductionBooking解构
    BookingProductionType: [],
    OrderUnit: "BB",
    // 页面验证信息
    ContractRules: {
      mediaBookingType: {
        message: "Please complete previous steps first",
        validation: true,
      },
      mediaRelateContractNumber: {
        message: messageConfig.getMessage("validformrequire"),
        validation: true,
      },
      productionBookingType: {
        message: "Please complete previous steps first",
        validation: true,
      },
      productionRelateContractNumber: {
        message: messageConfig.getMessage("validformrequire"),
        validation: true,
      },
      intercomContractNumber: {
        message: messageConfig.getMessage("validformrequire"),
        validation: true,
      }
    },
  }),
  getters: {
    isMedia(state) {
      return state.Contract.contractType === 'media'
    },
    isProduction(state) {
      return state.Contract.contractType === 'production'
    },
    isMediaProductionPlus(state) {
      return state.Contract.contractType === 'media+production'
    },
    mediaDisabled() {
      return !(this.isMedia)
    },
    mediaRenewalDisabled(state) {
      return this.mediaDisabled || (state.ContractBooking.mediaBookingType || "") !== 'renewal'
    },
    productionDisabled(state) {
      return !(this.isProduction) && !(state.Contract.contractType === "media+production")
    },
    productionRenewalDisabled(state) {
      return (this.productionDisabled) || (state.ContractBooking.productionBookingType || "").indexOf('newvisual') < 0;
    },
    ProductContractDisabled() {
      var disabled = useContractStore().disabled

      return this.Contract.contractType?.indexOf('production') < 0 ||
        (this.ContractBooking.productionBookingType || "").indexOf('newvisual') < 0 ||
        disabled
    },
    // Internal Split是否可编辑媒体日期
    campaignPeriodDisabled(state) {
      return state.Contract.contractType === "production"
    },
    // Internal Split是否可编辑媒体附加费
    loadingDisabled(state) {
      return state.Contract.contractType === "production"
    },
    // Internal Split是否可编辑媒体费用
    nettItemSumDisabled(state) {
      return state.Contract.contractType === "production"
    },
    // Internal Split是否可编辑制作费单价
    unitProdCostDisabled(state) {
      return state.Contract.contractType === "media"
    },
    // Internal Split是否可编辑分拆媒体费用
    mediaTotalIntlDisabled(state) {
      return state.Contract.contractType === "media" || state.Contract.contractType === "production";
    },
    // Internal Split是否可编辑分拆制作费用
    prodTotalIntlDisabled(state) {
      return state.Contract.contractType === "media" || state.Contract.contractType === "production";

    },
    // Internal Split是否可编辑销售服务费
    serviceFeeDisabled(state) {
      return state.Contract.contractType === "media"
    },
    // Internal Split是否可弹出特殊佣金安排
    comDisabled(state) {
      return state.Contract.contractType === "media" || state.Contract.contractType === "production";
    },
    // 特殊折扣
    specialDiscountDisabled(state) {
      return state.Contract.contractType === "production"
    }
  },
  actions: {
    async RefreshContractInfo() {
      const useContract = useContractStore()
      const ContractId = useContract.Id

      // 合同网络请求
      const res = await contractnet
        .getOrderContract(ContractId, this.OrderUnit)
        .then((res) => res.data);

      // 合同基本信息
      this.Contract = res.contract;

      this.ContractBooking = res.contractBooking;
      this.BookingProductionType = (this.ContractBooking.productionBookingType || "").split(">")
    },
    async toSave() {
      var ctrType = this.Contract.contractType;

      // 解构Booking
      const {
        mediaBookingType,
        mediaRelateContractNumber,
        productionBookingType,
        productionRelateContractNumber,
        intercomContractNumber,
      } = this.ContractBooking;

      // Contract Info Rules
      const rules = require('@/views/contract/js/contractInfoRules');
      const source = {
        contractType: ctrType,
        mediaBookingType: mediaBookingType,
        mediaRelateContractNumber: mediaRelateContractNumber,
        productionBookingType: productionBookingType,
        productionRelateContractNumber: productionRelateContractNumber,
        intercomContractNumber: intercomContractNumber,
        isITC: useContractStore().ContractSummary.isITC,
      };

      this.ContractBooking.validate = await validation.validate(source, rules).then((err) => err);

      if (this.ContractBooking.validate.length > 0) {
        return this.ContractBooking.validate[0].message
      }

      var messasge = await this.SaveData().then(res => res)
      if (messasge === "") {
        await this.RefreshContractInfo()
      }

      return messasge
    },
    /**
     * 保存数据
     */
    async SaveData() {
      const useContract = useContractStore()

      // 更新主信息
      var SaveInfoParam = {
        contractType: this.Contract.contractType,
        contractId: this.Contract.id,
        mediaCompanyEntityCode: this.Contract.mediaCompanyEntityCode,
        orderId: useContract.OrderId,
        productionCompanyEntityCode: this.Contract.productionCompanyEntityCode,
        mediaBookingType: this.ContractBooking.mediaBookingType,
        mediaRelateContractNumber: this.ContractBooking.mediaRelateContractNumber,
        productionBookingType: this.ContractBooking.productionBookingType,
        productionRelateContractNumber:
          this.ContractBooking.productionRelateContractNumber,
        intercomContractNumber: this.ContractBooking.intercomContractNumber,
        unit: useContract.Unit.alias
      };

      var contract_res = await contractnet
        .changeOrderContract(SaveInfoParam)
        .then((res) => res);

      var message = contract_res.data.resultMsg || "";

      useContract.Id = contract_res.data.id || 0;
      useContract.cId = contract_res.data.contract_Id || ""
      useContract.ContractNumber = contract_res.data.contractNo

      return message

    },
  }
})
